<template>
  <v-col cols="12">
    <div>
      <div class="text-h6">
        {{ personal.Personal.nombre }} {{ personal.Personal.segundoNombre }} {{ personal.Personal.apaterno }}
        {{ personal.Personal.amaterno }}
      </div>
      <div class="text-subtitle-1">CUIP: {{ personal.Personal.CUIP }}</div>
    </div>
    <div class="col-12 mt-2">
      <BaseInput v-model="personal.calificacion" label="Calificación" />
      <BaseInput v-model="personal.calificacionEvaluacion" label="Calificación de evaluador" />
      <BaseInputFile v-model="personal.file" label="Evidencia .jpg" />
      <BaseTextArea filled v-model="personal.comentario" label="Comentario" />
      <v-switch color="secondary" v-model="personal.asistencia" label="Asistió al curso" inset />
    </div>
    <div class="col-12 text-center">
      <TextButton color="secondary" class="primary--text mb-3" @click="guardarCambios"> Calificar curso </TextButton>
    </div>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BaseInput from './base/BaseInput.vue'
import BaseInputFile from './base/BaseInputFile.vue'
import BaseTextArea from './base/BaseTextArea.vue'
import TextButton from './base/TextButton.vue'
import Notificacion from '@src/modules/notificaciones/domain/Notificacion'
import { NotificationFactory, NOTIFICATION_TYPES } from '@src/modules/notificaciones/domain/NotificationFactory'

export default {
  components: {
    BaseInput,
    BaseTextArea,
    BaseInputFile,
    TextButton,
  },
  props: {
    personal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('cursoProgramado', ['getCursoProgramado']),
  },
  methods: {
    ...mapActions('cursoAsignado', ['updateAsignacionCursosPersonal']),
    ...mapActions('notificaciones', ['createNotification']),
    getFullName(persona) {
      if (!persona) return ''
      return [persona.nombre, persona.segundoNombre, persona.apaterno, persona.amaterno].filter(Boolean).join(' ')
    },
    getCursoProgramadoById(id) {
      const cursos = this.$store.getters['cursoProgramado/getCursosProgramados']
      return cursos.find((curso) => curso.id === id)
    },
    async guardarCambios() {
      const payload = {
        id: this.personal.id,
        idPersonal: this.personal.Personal.idPersonal,
        fk_idProgramacionCurso: this.personal.fk_idProgramacionCurso,
        comentario: this.personal.comentario,
        fk_idEstatus: this.personal.fk_idEstatus,
        asistencia: this.personal.asistencia,
        calificacion: this.personal.calificacion,
        calificacionEvaluacion: this.personal.calificacionEvaluacion,
        evidencia: this.personal.evidencia || (this.personal.file ? this.personal.file.name : ''),
        file: this.personal.file,
      }
      await this.updateAsignacionCursosPersonal([payload])
      await this.sendNotificacion()
      this.$emit('close')
    },
    async sendNotificacion() {
      const cursoProgramado = this.getCursoProgramadoById(this.personal.fk_idProgramacionCurso)
      const nombreEvaluador =
        cursoProgramado && cursoProgramado.Capacitador
          ? this.getFullName(cursoProgramado.Capacitador)
          : 'Sin capacitador'
      const nombreEvaluado =
        this.personal && this.personal.Personal ? this.getFullName(this.personal.Personal) : 'Sin evaluado'
      const notification = new NotificationFactory(Notificacion).createNotification(
        NOTIFICATION_TYPES.CALIFICACION_CURSO,
        {
          responsable: Number(localStorage.getItem('idPersonal')),
          afectado: this.personal.Personal.idPersonal,
          nombreEvaluador,
          nombreEvaluado,
          calificacion: this.personal.calificacion,
        }
      )
      await this.createNotification(notification)
    },
  },
}
</script>
